import React from "react";
import ExcelExampleTable from "ui/components/ExcelExampleTable/index";

function TabelaExemploExcelGrupoUnidade() {
  return (
    <ExcelExampleTable
      rows={[
        {
          obrigatorio: "Sim",
          cabecalho: "numero",
          tipo: "texto",
          observacao: "Número da unidade, igual cadastrado.",
        },
        {
          obrigatorio: "Não",
          cabecalho: "blocoQuadra",
          tipo: "texto",
          observacao: "Nome do Bloco/Quadra da unidade, igual cadastrado.",
        },
      ]}
    />
  );
}

export default TabelaExemploExcelGrupoUnidade;
